import React from 'react';
import WithCursorPointer from 'components/canvas/components/with-pointer-cursor';
import { Circle, Text, Line, Group } from 'react-konva';
import { useSideDrawerOperations } from 'state/side-drawer';
import { isMobile } from 'react-device-detect';
import { color } from 'styles/settings';

function GlobalLinksIndicator({ node, x }) {
  const { setNodeToDrawer } = useSideDrawerOperations();

  const links = node?.pointsTo.filter(
    (link) => link.to?.surface?.id !== node?.surface?.id,
  );

  function openDrawer(event) {
    event.cancelBubble = true;

    setNodeToDrawer(node);
  }

  if (links.length) {
    return (
      <WithCursorPointer>
        <Group
          x={x + 50}
          {...{
            [isMobile ? 'onTap' : 'onClick']: openDrawer,
          }}>
          <Circle radius={19} width={38} height={38} fill={color.brand.blue} />

          <Group>
            <Line
              stroke={color.brand.blue}
              strokeWidth={3}
              bezier={true}
              points={[0, 5, 5, 35, -25, 50, -50, 50, -50, 75, -100, 50]}
            />
            <Text
              fill={color.neutral.white}
              fontFamily="'Montserrat'"
              fontStyle="bold"
              fontSize={22}
              x={-15}
              width={30}
              y={-8}
              align="center"
              text={links.length.toString()}
            />
          </Group>
        </Group>
      </WithCursorPointer>
    );
  } else {
    return null;
  }
}

export default GlobalLinksIndicator;
